import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { CertificateNeutralPath, CourseNeutralPath } from 'navigation/Routes'
import { decorateUrl } from 'components/common/UTMscript'
import { fetchLearningPathCoursesAction } from 'pages/LearningPath/store'
import UI from './UI'

const mapStateToProps = ({ learningPath }) => ({
  courses: learningPath.Courses.Data,
  count: learningPath.Courses.Count,
  learningPathId: learningPath.LearningPath.Id,
  loading: learningPath.isLearningPathCoursesLoading,
  progressionLoading: learningPath.isLearningPathProgressionLoading,
  take: learningPath.take,
  skip: learningPath.skip
})

const mapDispatchToProps = dispatch => ({
  fetchLearningPathCourses: (pathId, rowsPerPage, skip) => dispatch(fetchLearningPathCoursesAction(pathId, rowsPerPage, skip)),
  goToCourse: (slug) => dispatch(push(decorateUrl(`${CourseNeutralPath}/${slug}`))),
  goToCertificate: (slug) => dispatch(push(decorateUrl(`${CertificateNeutralPath}/${slug}`)))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
